import { createContext, useContext, useEffect } from 'react';

export interface RecordOrganisation {
  /** The organisation of the record on screen, once the page knows it. */
  id: string | null;
  setId: (id: string | null) => void;
}

export const RecordOrganisationContext = createContext<RecordOrganisation | null>(null);

export function useRecordOrganisationId(): string | null {
  return useContext(RecordOrganisationContext)?.id ?? null;
}

/*
 * A detail page names the organisation its record belongs to, so the header picker
 * shows that one instead of the global choice. Cleared again when the page goes.
 */
export function useRecordOrganisation(organisationId: string | null | undefined): void {
  const setId = useContext(RecordOrganisationContext)?.setId;

  useEffect(() => {
    if (!setId) return;

    setId(organisationId ?? null);
    return () => setId(null);
  }, [setId, organisationId]);
}
